import { Reveal } from "./Reveal";

export const SectionHeading = ({ chapter, eyebrow, title, script, dark = false, align = "left" }) => (
  <div className={`relative ${align === "center" ? "text-center" : ""}`} data-testid={`heading-${eyebrow?.toLowerCase().replace(/\s+/g, "-")}`}>
    {chapter && (
      <span
        aria-hidden
        className={`pointer-events-none absolute -top-16 md:-top-24 select-none font-serif text-[7rem] md:text-[12rem] leading-none ${
          dark ? "text-outline-cream" : "text-outline-gold"
        } ${align === "center" ? "left-1/2 -translate-x-1/2" : "-left-2 md:-left-6"}`}
      >
        {chapter}
      </span>
    )}
    <Reveal>
      <p className={`text-xs md:text-sm tracking-[0.35em] uppercase mb-4 ${dark ? "text-gold" : "text-gold-dark"}`}>
        {chapter ? `Chapter ${chapter} — ` : ""}{eyebrow}
      </p>
      <h2 className={`font-serif text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.05] ${dark ? "text-cream" : "text-espresso"}`}>
        {title}{" "}
        {script && <span className="font-script block mt-2 text-4xl md:text-6xl text-gold font-normal">{script}</span>}
      </h2>
    </Reveal>
  </div>
);
